module.exports = __webpack_public_path__ + "f9b3ca539d8528b67ae393d1ea43197a.pdf";